/**
 * OAS Free Gift — multi trigger products + multi gifts per rule.
 * Config: #oas-free-gift-config (sections/oasmobility-free-gift.liquid)
 */
(function () {
  if (window.__oasFreeGiftInited) return;
  window.__oasFreeGiftInited = true;

  var PROP_GIFT = '_oas_free_gift';
  var PROP_RULE = '_oas_free_gift_rule';
  var PROP_GIFT_PID = '_oas_gift_product_id';
  var PROP_LABEL = '_oas_gift_label';

  var configEl = document.getElementById('oas-free-gift-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  if (!config || !config.enabled || !config.rules || !config.rules.length) return;

  var rules = config.rules;
  var syncing = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cartUrl(path) {
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getCart() {
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function isOurGiftLine(item) {
    var props = item.properties || {};
    return props[PROP_GIFT] === 'true' || props[PROP_GIFT] === true;
  }

  function triggerIdSet(rule) {
    var set = {};
    (rule.triggerProductIds || []).forEach(function (id) {
      set[String(id)] = true;
    });
    return set;
  }

  function cartHasTrigger(cart, rule) {
    var triggers = triggerIdSet(rule);
    return (cart.items || []).some(function (item) {
      if (isOurGiftLine(item)) return false;
      return !!triggers[String(item.product_id)];
    });
  }

  function findGiftLinesForRule(cart, rule) {
    return (cart.items || []).filter(function (item) {
      if (!isOurGiftLine(item)) return false;
      var props = item.properties || {};
      return String(props[PROP_RULE] || '') === String(rule.id);
    });
  }

  function findGiftLine(cart, rule, gift) {
    return (cart.items || []).find(function (item) {
      if (!isOurGiftLine(item)) return false;
      var props = item.properties || {};
      if (String(props[PROP_RULE] || '') !== String(rule.id)) return false;
      if (props[PROP_GIFT_PID] && String(props[PROP_GIFT_PID]) === String(gift.productId)) {
        return true;
      }
      return Number(item.variant_id) === Number(gift.variantId);
    });
  }

  function addGifts(rule, giftsToAdd) {
    if (!giftsToAdd.length) return Promise.resolve(null);

    var items = giftsToAdd.map(function (gift) {
      var props = {};
      props[PROP_GIFT] = 'true';
      props[PROP_RULE] = String(rule.id);
      props[PROP_GIFT_PID] = String(gift.productId);
      if (config.giftBadge) {
        props[PROP_LABEL] = config.giftBadge;
      }
      return {
        id: Number(gift.variantId),
        quantity: 1,
        properties: props
      };
    });

    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          console.warn('[OAS Free Gift] add failed', rule.label || rule.id, data);
          return null;
        }
        return data;
      });
    });
  }

  function changeLineQty(lineKey, quantity) {
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (r) {
      return r.json();
    });
  }

  function notifyCartUpdated(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'oas-free-gift', cart: cart }
      })
    );
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function syncRule(cart, rule) {
    var hasTrigger = cartHasTrigger(cart, rule);
    var gifts = rule.gifts || [];
    var chain = Promise.resolve();
    var changed = false;

    if (hasTrigger) {
      var missing = gifts.filter(function (gift) {
        return !findGiftLine(cart, rule, gift);
      });

      if (missing.length) {
        chain = chain.then(function () {
          return addGifts(rule, missing).then(function (res) {
            if (res) {
              changed = true;
              return getCart().then(function (fresh) {
                cart = fresh;
              });
            }
          });
        });
      }

      if (config.oneGiftPerItem) {
        chain = chain.then(function () {
          var qtyChain = Promise.resolve();
          gifts.forEach(function (gift) {
            qtyChain = qtyChain.then(function () {
              var line = findGiftLine(cart, rule, gift);
              if (line && line.quantity > 1) {
                return changeLineQty(line.key, 1).then(function (fresh) {
                  changed = true;
                  if (fresh && fresh.items) cart = fresh;
                });
              }
            });
          });
          return qtyChain;
        });
      }
    } else if (config.removeWhenTriggerRemoved) {
      var giftLines = findGiftLinesForRule(cart, rule);
      giftLines.forEach(function (line) {
        chain = chain.then(function () {
          return changeLineQty(line.key, 0).then(function (fresh) {
            changed = true;
            if (fresh && fresh.items) cart = fresh;
            else {
              return getCart().then(function (c) {
                cart = c;
              });
            }
          });
        });
      });
    }

    return chain.then(function () {
      return { cart: cart, changed: changed };
    });
  }

  function syncFreeGifts() {
    if (syncing) return Promise.resolve(null);
    syncing = true;
    window.__oasFreeGiftAdding = true;

    return getCart()
      .then(function (cart) {
        var chain = Promise.resolve({ cart: cart, changed: false });

        rules.forEach(function (rule) {
          chain = chain.then(function (state) {
            return syncRule(state.cart, rule).then(function (result) {
              return {
                cart: result.cart,
                changed: state.changed || result.changed
              };
            });
          });
        });

        return chain;
      })
      .then(function (result) {
        syncing = false;
        window.__oasFreeGiftAdding = false;
        if (result && result.changed && result.cart) {
          notifyCartUpdated(result.cart);
        }
        return result;
      })
      .catch(function (err) {
        syncing = false;
        window.__oasFreeGiftAdding = false;
        console.warn('[OAS Free Gift] sync error', err);
        return null;
      });
  }

  function shouldInterceptCartUrl(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : input && input.url;
    var promise = originalFetch.apply(this, arguments);

    if (!shouldInterceptCartUrl(url) || window.__oasFreeGiftAdding) {
      return promise;
    }

    return promise.then(function (response) {
      if (!response || !response.ok) return response;
      return syncFreeGifts().then(function () {
        return response;
      });
    });
  };

  document.addEventListener('cart:change', function (event) {
    if (window.__oasFreeGiftAdding) return;
    if (event.detail && event.detail.baseEvent === 'oas-free-gift') return;
    syncFreeGifts();
  });

  document.addEventListener('cart:refresh', function () {
    if (window.__oasFreeGiftAdding) return;
    setTimeout(function () {
      if (!window.__oasFreeGiftAdding) syncFreeGifts();
    }, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncFreeGifts();
    });
  } else {
    syncFreeGifts();
  }
})();
